var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-5 {\r\n        fill: #f7a600;\r\n      }\r\n\r\n      .cls-2, .cls-3, .cls-4 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2, .cls-3, .cls-4, .cls-5 {\r\n        stroke: #f7a600;\r\n        stroke-linecap: round;\r\n      }\r\n\r\n      .cls-2, .cls-3 {\r\n        stroke-linejoin: round;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke-miterlimit: 10;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12241",
    "data-name": "Group 12241",
    transform: "translate(22068.5 7492.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1830",
    "data-name": "Ellipse 1830",
    className: "cls-1",
    cx: 1.233,
    cy: 1.257,
    rx: 1.233,
    ry: 1.257,
    transform: "translate(-22061.146 -7485.88)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7162",
    "data-name": "Path 7162",
    className: "cls-2",
    d: "M22.687,7.572A3.846,3.846,0,0,1,21.2,4.52a3.748,3.748,0,1,1,7.5,0,3.878,3.878,0,0,1-1.487,3.052",
    transform: "translate(-22084.814 -7492.7)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10173",
    "data-name": "Group 10173",
    transform: "translate(-22068 -7483.923)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7163",
    "data-name": "Path 7163",
    className: "cls-3",
    d: "M53.573,1.784a7.971,7.971,0,0,1,3.186,1.873",
    transform: "translate(-43.128 -1.755)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7164",
    "data-name": "Path 7164",
    className: "cls-4",
    d: "M5.833,0A8.249,8.249,0,0,1,0,7.923",
    transform: "translate(5.833 7.923) rotate(180)"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_1268",
    "data-name": "Line 1268",
    className: "cls-4",
    x2: 11.6,
    transform: "translate(-22063.6 -7476.4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7478",
    "data-name": "Path 7478",
    className: "cls-5",
    d: "M7,0h6",
    transform: "translate(-22065 -7479.6)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMl);
export default __webpack_public_path__ + "static/media/ml.b408f155ab592c25338553cc4c6a3393.svg";
export { ForwardRef as ReactComponent };